import React from "react";
const Claims = ({}) => {
  const onFormSubmit = () => {
    window.scrollTo(0, 0)
  }
  return (
    <>
      <div>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSf7_8gnQTrQpoWFTMaRgfb7qPulDF9AiYYkyZSUHzvuv1yx1A/viewform"
          scrolling="no"
          style={{ minWidth: "100%", height: "1650px", border: "none" }}
          onLoad={onFormSubmit}
        >
          Loading…
        </iframe>
      </div>
    </>
  );
};

export default Claims;
